// MU
import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      "@media (min-width: 576px)": {
        marginTop: "10px",
      },
      "& #batalha, #torneio": {
        fontSize: "16px",
      },
      "&.exibe": {
        animation: "0.25s $animaControlesUp",
      },
      "&.oculta": {
        animation: "0.25s $animaControlesDown",
        display: "none",
      },
    },
    "@keyframes animaControlesUp": {
      from: {
        transform: "translateY(200%)",
      },
      to: {
        transform: "translateY(0%)",
      },
    },
    "@keyframes animaControlesDown": {
      from: {
        transform: "translateY(0%)",
        opacity: 1,
      },
      to: {
        transform: "translateY(200%)",
        display: "none",
      },
    },
  })
);
